import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';

export interface LoadLayerParams {
	handler: AnyHandler;
	layer: SLLayer;
}

@Injectable({
	providedIn: 'root'
})
export class LoadLayerDialogService {
	public request$: Subject<LoadLayerParams> = new Subject();
	constructor() { }


	Show(
		handler: AnyHandler,
		layer: SLLayer
	) {
		const params: LoadLayerParams = {
			handler: (handler),
			layer: (layer)
		};

		this.request$.next(params);
	}
}
